import styled from 'styled-components'

export const MTLinkStyled = styled.a`
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: ${({theme, color})=>color || theme.primary}
`
